import analyticsLoggerImpl from '@autopass-web/mochi-analytics';

class Analytics {
  init = (key, userId) => {
    analyticsLoggerImpl.init(key);
    if (userId) analyticsLoggerImpl.setUserId(userId);
  };

  log = (name, properties) => analyticsLoggerImpl.log(name, properties);

  pageView = () => this.log('發票設定頁-選擇捐贈團體頁_pageview');
  input_onClick = () => this.log('發票設定頁-選擇捐贈團體頁-輸入框_點擊');
  item_onClick = ({ code, unit }) =>
    this.log('發票設定頁-選擇捐贈團體頁_點擊', {
      捐贈單位內容: `${code},${unit}`,
    });
}

export default new Analytics();
